import * as React from "react";
import Application from "../metamodel/Application";
import {Link} from "react-router-dom";
import FilterContainer from "../homepage/components/filters/FilterContainer";
import {EntityFilters, SearchFilter} from "../homepage/types";
import Entity from "../metamodel/Entity";
import EntityFiltersSerializer from "../homepage/EntityFiltersSerializer";
import * as H from "history";
import Header from "../homepage/components/header";

export interface SwitchpageProps {
    metaModel: Application,
    history: H.History,
    logoUrl: string,
    backgroundUrl: string
}

interface SwitchPageState {
    activeEntity: Entity,
    filters: {[entity:string]: {[key: string]: SearchFilter}}
}


export default class Switchpage extends React.Component<SwitchpageProps, SwitchPageState> {

    constructor(props: SwitchpageProps) {
        super(props);
        this.state = {
            activeEntity: props.metaModel.entities[0],
            filters: {}
        };
    }

    public componentWillMount(): void {
        if (this.props.metaModel.entities.length <2) {
            this.props.history.push(`/${this.state.activeEntity.id}/zoeken/pagina/1`);
        }
    }


    public render() {
        const onChangeFilter = (e: EntityFilters) => this.setState((prevState: SwitchPageState) => {
            return {...prevState, filters: {
                    ...prevState.filters,
                    [prevState.activeEntity.id]: e
                }};
        });
        const onChangeTab = (entity: Entity, e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            return this.setState({activeEntity: entity});
        };
        const params = EntityFiltersSerializer.serialize(this.state.filters[this.state.activeEntity.id], new URLSearchParams());
        const submitLink = `/${this.state.activeEntity.id}/zoeken/pagina/1?${params}`;
        const activeFilters = Object.values(this.state.filters[this.state.activeEntity.id] || []);
        const hasFilters = activeFilters.length > 0 && activeFilters.some((v: SearchFilter) => {
            if (Array.isArray(v)) {
                return v.length > 0;
            }
            return v !== undefined;
        });

        return <div id="wrap-page" className="bg-scroll home-minimal"
                    style={{backgroundImage: `url('${this.props.backgroundUrl}')`}}>

            <Header metaModel={this.props.metaModel}/>
            <section id="main">
                <div className="header-page bg-scroll m-bottom-0">

                    <div className="container">

                        <div className="header-page__form header-page__form--high">

                            <div className="tb">
                                <div className="tb__cell">
                                    <div className="header-page__banner text-left">
                                        <h2 className="banner__title">{this.props.metaModel.name.normalize()}</h2>
                                        <Link className="listgo-btn btn-primary" to="/over-de-app">Meer
                                            informatie</Link>
                                    </div>
                                </div>
                                <div className="tb__cell">

                                    <div className="form-high form-transparent">

                                        <div className="tab tab--form">
                                            <ul className="tab__nav">
                                                {this.props.metaModel.entities.map(e => <li key={e.id}
                                                                                            className={e === this.state.activeEntity ? "active" : undefined}>
                                                    <a href="" onClick={onChangeTab.bind(this, e)}>{e.name}</a></li>)}
                                            </ul>
                                            <div className="tab__content">
                                                {this.props.metaModel.entities.map(e => <div key={e.id}
                                                                                             className={e === this.state.activeEntity ? "tab__panel active" : "tab__panel"}>
                                                    <form action="#" className="form form--planten">
                                                        <FilterContainer
                                                            filters={e.fields.filter(f => f.searchable).slice(0, 2)}
                                                            activeFilters={this.state.filters[this.state.activeEntity.id] || {}}
                                                            disableFacets={true}
                                                            onChange={onChangeFilter}
                                                            facets={{}}/>
                                                        <div className="form-item item--submit">
                                                            <Link className="listgo-btn btn-primary" to={submitLink}>{hasFilters ? `Zoeken` : `Bekijk alle ${this.state.activeEntity.name}`}</Link>
                                                        </div>
                                                    </form>

                                                </div>)}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/switchpage/switchpage.tsx